/* RW13 2026-10-03 (staging): GA4 custom events for Rubber Washer Warehouse.
   GA4 (G-MBTC227W9L) is loaded by the Google & YouTube app's web pixel, which runs in the page ("OPEN" runtime) and
   defines window.gtag. Every event goes to gtag when it exists (queued for up to 20 s if gtag is not there yet) and to
   Shopify's customer-events bus (Shopify.analytics.publish), so a custom pixel could forward them later.
   Events here: request_size_click, notify_submit_view (the notify form was SEEN; nothing is submitted),
   material_compare_open, preset_qty_click, size_chart_filter.
   size_finder_used is sent by rww-size-finder.js. Listeners are delegated and passive: no layout work, no network of its own. */
(function () {
  if (window.rwwTrack) return;
  var q = [], tries = 0, timer = null;
  function pub(n, p) { try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(n, p); } catch (e) {} }
  function flush() {
    if (typeof window.gtag === 'function') { while (q.length) { var x = q.shift(); try { window.gtag('event', x[0], x[1]); } catch (e) {} } timer = null; return; }
    if (++tries > 40) { q.length = 0; timer = null; return; }
    timer = setTimeout(flush, 500);
  }
  function send(n, p) {
    p = p || {};
    pub(n, p);
    q.push([n, p]);
    if (!timer) flush();
  }
  window.rwwTrack = send;

  function where(el) {
    if (el.closest('.rhb')) return 'size_chart';
    if (el.closest('.rqf, [data-rqf]')) return 'size_finder';
    if (el.closest('.rsh')) return 'search';
    if (el.closest('.rww-alts')) return 'alternatives';
    if (el.closest('.rss')) return 'size_siblings';
    if (document.body.classList.contains('template-product') || /\/products\//.test(location.pathname)) return 'product';
    return 'other';
  }
  function handle() { var m = location.pathname.match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; }

  // request_size_click: every "request this size" path (hub row, finder miss, search miss, product notify links).
  var REQ = 'a[href*="#rww-notify"], a[href*="rww_size="], [data-req], [data-hub-go="request"], [data-rsh-ev="request"]';
  // preset_qty_click: product-page quantity presets and the notify form's quick quantities.
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var a = t.closest(REQ);
    if (a) {
      var href = a.getAttribute('href') || '';
      var mm = href.match(/[?&]rww_m=([^&#]+)/);
      send('request_size_click', { source: where(a), material: mm ? decodeURIComponent(mm[1]) : '', link_url: href.slice(0, 120) });
      return;
    }
    var b = t.closest('.rqp__b');
    if (b) { send('preset_qty_click', { qty: +b.getAttribute('data-q') || 0, source: 'product', product: handle() }); return; }
    var n = t.closest('[data-rww-nq]');
    if (n) send('preset_qty_click', { qty: +n.getAttribute('data-rww-nq') || 0, source: 'notify_form', product: handle() });
  }, { passive: true });

  // material_compare_open: the collapsed "Compare the 7 materials" panel on product pages ('toggle' does not bubble: capture).
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details.rmc__d') || !d.open) return;
    var cur = d.querySelector('.is-cur, [aria-current], .rmc__cur');
    send('material_compare_open', { surface: where(d), current_material: cur ? ((cur.querySelector('th, strong, b, h3') || cur).textContent || '').trim().slice(0, 30) : '', product: handle() });
  }, true);

  // size_chart_filter: the size-chart hub re-renders synchronously in its own change handler on the form, which runs
  // before this document-level one, so its "Showing x of N sizes · k in stock" line is already updated here.
  document.addEventListener('change', function (e) {
    var f = e.target && e.target.closest && e.target.closest('[data-hub-f]'); if (!f) return;
    var v = function (k) { var s = f.querySelector('[data-k="' + k + '"]'); return s ? (s.type === 'checkbox' ? s.checked : s.value) : ''; };
    var c = ((document.querySelector('[data-hub-c]') || {}).textContent || '').replace(/,/g, '');
    var n = c.match(/of (\d+) size/), k = c.match(/(\d+) in stock/);
    send('size_chart_filter', { changed: e.target.getAttribute('data-k') || '', material: v('m') || 'any', od: v('od') || 'any', id: v('id') || 'any', thk: v('t') || 'any', in_stock_only: !!v('stock'), results: n ? +n[1] : -1, in_stock: k ? +k[1] : -1 });
  }, { passive: true });

  // notify_submit_view: the back-in-stock form (#rww-notify) is at least half on screen. View only; never submits.
  var seen = {};
  function watch() {
    var el = document.getElementById('rww-notify');
    if (!el || el.__rwwObs || !('IntersectionObserver' in window)) return;
    el.__rwwObs = 1;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        if (!x.isIntersecting) return;
        var m = (el.querySelector('[data-rww-nm]') || {}).textContent || '';
        var key = handle() + '|' + m;
        io.disconnect();
        if (seen[key]) return; seen[key] = 1;
        send('notify_submit_view', { material: m.trim().slice(0, 30), product: handle(), from_hub: /[?&]rww_m=/.test(location.search) });
      });
    }, { threshold: 0.5 });
    io.observe(el);
  }
  function rescan() { setTimeout(watch, 700); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  // The form is re-rendered when the material changes (variant content): look again after a change.
  document.addEventListener('change', rescan, { passive: true });
})();
